import { combineEpics } from 'redux-observable'
import authenticationEpic from './authentication'
import catalogRedirectionsEpic from './catalogRedirections'
import checkoutRequestEpic from './checkout'
import checkoutResetEpic from './checkoutReset'
import { configuratorAutoSelectEpic, fetchCheckinDatesEpic } from './configuratorAutoSelect'
import configuratorSelectionChangeEpic from './configuratorSelectionChange'
import contextEpic from './context'
import faviconEpic from './favicon'
import filtersEpics from './filters'
import lastViewedProductsEpic from './lastViewedProducts'
import momentLocaleEpic from './momentLocale'
import packageAutoSelectEpic from './packageAutoSelect'
import pageTitleEpic from './pageTitle'
import productVisitEpic from './visits'
import redirectRouting from './redirectRouting'
import redirectToNavigation from './redirectToNavigation'
import removeCypherSSOEpic from './removeCypherSSO'
import resourcesEpic from './resources'
import reviewsEpic from './reviews'
import setLanguageEpic from './setLanguage'
import trackingEpics from './tracking'
import universeViewEpic from './viewUniverse'
import { packageStocksEpic, pickersBindingsStockEpic, productStocksEpic, saleStocksEpic } from './stock'
import { periodicalVersionCheckEpic, refetchAfterVersionChangeEpic } from './version'
import { saleChangesEpic, saleWillChangeEpic } from './saleChanges'
import resetSelectionOnToggleCheapestPriceEpic from './resetSelectionOnToggleCheapestPrice'
import toggleCheapestPriceEpic from './toggleCheapestPrice'

export default combineEpics(
  saleChangesEpic,
  contextEpic,
  authenticationEpic,
  momentLocaleEpic,
  setLanguageEpic,
  filtersEpics,
  catalogRedirectionsEpic,
  checkoutResetEpic,
  checkoutRequestEpic,
  fetchCheckinDatesEpic, // Need to be before configuratorAutoSelectEpic because configuratorAutoSelectEpic is changing the stream
  configuratorAutoSelectEpic,
  configuratorSelectionChangeEpic,
  faviconEpic,
  lastViewedProductsEpic,
  saleWillChangeEpic,
  packageAutoSelectEpic,
  pageTitleEpic,
  periodicalVersionCheckEpic,
  productStocksEpic,
  packageStocksEpic,
  pickersBindingsStockEpic,
  universeViewEpic,
  productVisitEpic,
  redirectRouting,
  refetchAfterVersionChangeEpic,
  removeCypherSSOEpic,
  resourcesEpic,
  reviewsEpic,
  saleStocksEpic,
  trackingEpics,
  resetSelectionOnToggleCheapestPriceEpic,
  toggleCheapestPriceEpic,
  redirectToNavigation
)
